module.exports = __webpack_public_path__ + "img/arrowsBlue.a7c0cdc7.png";